export default "__VITE_ASSET__DIQA9EoD__"